import { z } from "zod";

import { dateSchema } from "./utils";

const teamSchema = z.object({
  team_id: z.coerce.string(),
  abbreviation: z.string(),
  icon_background_colors: z
    .array(
      z.object({
        base: z.string(),
        light_background: z.string(),
        dark_background: z.string(),
      }),
    )
    .catch([]),
  logo_url: z.string().nullish().catch(null),
  name: z.string(),
  record: z.object({
    losses: z.number().catch(0),
    ties: z.number().catch(0),
    wins: z.number().catch(0),
  }),
  score: z.number().nullish().catch(null),
});

const sportDataSchema = z.object({
  away_team: teamSchema,
  clock_display: z.string().nullish().catch(null),
  home_team: teamSchema,
  background: z.object({
    away_team: z.string(),
    home_team: z.string(),
    style: z.string(),
  }),
  is_live: z.boolean().catch(false),
  is_over: z.boolean().catch(false),
  period: z.string().nullish().catch(null),
  time: z.string().nullish().catch(null),
});

const sportSchema = z.object({
  id: z.coerce.string(),
  league: z.string(),
  sport_type: z.string(),
  sport_display_name: z.string(),
  start_at: dateSchema,
  data: sportDataSchema,
  url: z.string(),
});

type Team = z.infer<typeof teamSchema>;
type SportData = z.infer<typeof sportDataSchema>;
type Sport = z.infer<typeof sportSchema>;

export {
  sportSchema,
  teamSchema,
  sportDataSchema,
  type Sport,
  type SportData,
  type Team,
};
